import React from 'react'
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { Dropdown } from "../../../FlowConfigurationInputs";
function ConvertDateToString({ action, setOpenVariable, variables }) {
  const label = "CONTENT.CONFIGURATION-FORM.";
  const { t } = useTranslation();
  const options = {
    dropdown: {
      data: [
        {
          value: "dd-mm-yyyy",
          label: "DD-MM-YYYY",
        },
        {
          value: "mm-dd-yyyy",
          label: "MM-DD-YYYY",
        },
        {
          value: "yyyy-mm-dd",
          label: "YYYY-MM-DD",
        },
        {
          value: "dd.mm.yyyy",
          label: "DD.MM.YYYY",
        },
        {
          value: "mm.dd.yyyy",
          label: "MM.DD.YYYY",
        },
        {
          value: "yyyy.mm.dd",
          label: "YYYY.MM.DD",
        },
        {
          value: "dd/mm/yyyy",
          label: "DD/MM/YYYY",
        },
        {
          value: "mm/dd/yyyy",
          label: "MM/DD/YYYY",
        },
        {
          value: "yyyy/mm/dd",
          label: "YYYY/MM/DD",
        },
      ],
      defaultValue: "dd-mm-yyyy",
    }
  };
  return (
    <div>
      <div className='form-element'>
        {t(label + 'DATE.SOURCE-DATE')}
        <TextInput
          action={action}
          setOpenVariable={setOpenVariable}
          variables={variables}
          inputName="sourceDate"
          isRequired={true}
          fieldType="date" 
          displayName={t(label + 'DATE.SOURCE-DATE')}
        />
      </div>
      <div className="form-element">
            {t(label + "STRING.DATE-FORMAT-TYPE")}
            <Dropdown
              action={action}
              inputName="newFormat"
              options={options.dropdown}
              isRequired={true}
            />
      </div>
      <div className='form-element'>
        {t(label + 'DATE.ASSIGN')}
        <VariablePicker
          action={action}
          setOpenVariable={setOpenVariable}
          variables={variables}
          inputName="set"
          isRequired={true}
        />
      </div>
    </div>
  )
}

export default ConvertDateToString;